import React, { useEffect, useMemo, useState } from "react";
import '../../../node_modules/bootstrap/dist/css/bootstrap.min.css';
import TableContainer from '../../components/Common/TableContainer';
import * as Yup from "yup";
import { useFormik } from "formik";

//import components
import Breadcrumbs from '../../components/Common/Breadcrumb';
import DeleteModal from '../../components/Common/DeleteModal';

import InvitationFormModal from "./partials/modals/InvitationFormModal";
import AccountFormModal from "./partials/modals/AccountFormModal";
import LockAccountConfirmationModal from "./partials/modals/LockAccountConfirmationModal";
import UnlockAccountConfirmationModal from "./partials/modals/UnlockAccountConfirmationModal";

import {
    getAccounts as onGetAccounts,
    getRoles as onGetRoles,
    addNewAccount as onAddNewAccount,
    //addNewInvitation as onAddNewInvitation,
    sendInvitation as onSendInvitation,
    resendInvitation as onResendInvitation,
    updateAccount as onUpdateAccount,
    deleteAccount as onDeleteAccount,
    lockAccount as onLockAccount,
    unlockAccount as onUnlockAccount,
} from "store/actions";

//redux
import { useSelector, useDispatch } from "react-redux";
import { createSelector } from "reselect";

import {
    Col,
    Row,
    UncontrolledTooltip,
    Modal,
    ModalHeader,
    ModalBody,
    Form,
    Input,
    FormFeedback,
    Label,
    Card,
    CardBody,
    UncontrolledDropdown,
    DropdownToggle,
    DropdownMenu,
    DropdownItem,
    Badge,
    Button,
} from "reactstrap";
import Spinners from "components/Common/Spinner";
import { ToastContainer } from "react-toastify";
import { Link } from "react-router-dom";

const Account = () => {

    //meta title
    document.title = "Utilisateurs | CinzanEdu";

    const [modal, setModal] = useState(false);
    const [isEdit, setIsEdit] = useState(false);
    const [account, setAccount] = useState(null);

    const [accountModal, setAccountModal] = useState({
        isOpen: false,
        isEdit: false,
        account: null
        });

    // Multiple modals state
    const [modals, setModals] = useState({
        invitation: false,
        editAccount: false,
        lockAccount: false,
        unlockAccount: false,
        addAccount: false,
    });
    

    // validation
    const validation = useFormik({
        // enableReinitialize : use this flag when initial values needs to be changed
        enableReinitialize: true,

        initialValues: {
            uid: account?.uid || '',
            email: account?.email || '',
            role_id: account?.role_id || '',
            password: '',
            password_confirmation: '',
           
            
        },
        validationSchema: Yup.object({
           
            email: Yup.string().email("La valeur saisie doit etre une addresse email").required("Veuillez saisir l'email"),
            role_id: Yup.number().required("Veuillez sélectionner le role"),
            password: Yup.string().required("Veuillez saisir le mot de passe"),
            password_confirmation: Yup.string().oneOf([Yup.ref("password"), null], 'Les deux mots de passe sont different')
            //password_confirmation: Yup.string().required("Veuillez saisir la confirmation du mot de passe"),
            
  
        }),
        onSubmit: (values) => {
            if (isEdit) {
                //const payload = { series_category: values }
                const updateAccount = {
                    //id: values.id,
                    uid: values.uid,
                    email: values.email,
                    role_id: values.role_id,
                    password: values.password,
                    password_confirmation: values.password_confirmation
                    
                    
                };
                // update movie category
                dispatch(onUpdateAccount(updateAccount));
                validation.resetForm();
            } else {
                const newAccount = {
                    //id: values["id"],
                    //uid: values["uid"],
                    
                    email: values["email"],
                    role_id: values["role_id"],
                    password: values["password"],
                    password_confirmation: values["password_confirmation"],
                   
                   
                };
                // save new movie category
                dispatch(onAddNewAccount(newAccount));
                validation.resetForm();
            }
            toggle();
        },
    });

    const dispatch = useDispatch();

    // C’est une fonction qui prend tout le state Redux et renvoie seulement la partie SerialMovieReducer
    const AccountProperties = createSelector(
        (state) => state.accountReducer, 
        (accountReducer) => ({
            accounts: accountReducer.accounts,
            loading: accountReducer.loading
        })
    );

    // Get roles
    // C’est une fonction qui prend tout le state Redux et renvoie seulement la partie SerialMovieReducer
    const RoleProperties = createSelector(
        (state) => state.roleReducer, 
        (roleReducer) => ({
            roles: roleReducer.roles,
            loading: roleReducer.loading
        })
    );

    const {accounts, loading} = useSelector(AccountProperties);
    const {roles} = useSelector(RoleProperties);

    // --- CORRECTION ROBUSTE ---
    // Ferme le modal automatiquement quand le chargement est terminé sans erreur
    useEffect(() => {
        if (!loading && accountModal.isOpen) {
            closeAccountModal();
        }
    }, [loading]);

    const [isLoading, setLoading] = useState(loading)


    // Montage du composant
    useEffect(() => {
        if (accounts && !accounts.length) {
            dispatch(onGetAccounts());
        }
    }, [dispatch, accounts]);

    useEffect(() => {
        if (roles && !roles.length) {
            dispatch(onGetRoles());
        }
    }, [dispatch, roles]);

    const toggle = () => {
        if (modal) {
            setModal(false);
            setAccount(null);
        } else {
            setModal(true);
        }
    };

    const handleAccountClick = arg => {
        const account = arg;
        setAccount({
            //id: serialaccount.id,
            uid: account.uid,
            email: account.email,
            role_id: account.role_id,
           
        });


        // Set for update url
        setIsEdit(true);

        toggle();
    };


    const onClickResendInvitation = arg => {
        const account = arg;

        const data = {email: account.email};

        dispatch(onResendInvitation(data));

    };

    
    const [deleteModal, setDeleteModal] = useState(false);

    const onClickDelete = (account) => {
        setAccount(account);
        setDeleteModal(true);
    };

    const handleDeleteAccount = () => {


        if (account && account.id) {
            dispatch(onDeleteAccount(account));
            setDeleteModal(false);
        }
    };

    const onClickNewInvitation = () => {
        setModals({ 
            invitation: true, 
            editAccount: false,
            lockAccount: false,
            unlockAccount: false,
            addAccount: false
        });
    }

    // CLOSE ALL MODALS
    const closeAllModals = () => {
        setModals({ 
            invitation: false, 
            editAccount: false ,
            lockAccount: false,
            unlockAccount: false,
            addAccount: false
        });
    }

    // OPEN MODAL ON LOCK ACCOUNT CLICK
    const onLockAccountClick =  (account) => {

        setAccount(account);
        setModals({ 
            invitation: false, 
            editAccount: false,
            lockAccount: true,
            unlockAccount: false,
            addAccount: false
        });

    }

    // OPEN MODAL ON UNLOCK ACCOUNT CLICK
    const onUnlockAccountClick =  (account) => {

        setAccount(account);
        setModals({ 
            invitation: false, 
            editAccount: false,
            lockAccount: false,
            unlockAccount: true
        });

    }

    // HANDLE LOCK ACCOUNT ON SUBMIT
    const handleLockAccount = () => {
        
        if (account && account.id) {
            dispatch(onLockAccount(account));
            //setDeleteModal(false);
            closeAllModals();
        }

        
    }


     // HANDLE UNLOCK ACCOUNT ON SUBMIT
    const handleUnlockAccount = () => {
        
        if (account && account.id) {
            dispatch(onUnlockAccount(account));
            //setDeleteModal(false);
            closeAllModals();
        }

        
    }

    // Ouvrir le modal en mode ajout
const onClickAddAccount = () => {
  setAccountModal({
    isOpen: true,
    isEdit: false,
    account: null
  });
};

// Ouvrir le modal en mode édition
const onClickEditAccount = (account) => {
  setAccountModal({
    isOpen: true,
    isEdit: true,
    account: account
  });
};

// Fermer le modal
const closeAccountModal = () => {
  setAccountModal({ isOpen: false, isEdit: false, account: null });
};

    const columns = useMemo(
        () => [
            {
                header: 'ID',
                accessorKey: "id",
                enableColumnFilter: false,
                enableSorting: true,
                cell: (cellProps) => {
                    return <Link to="#" className="text-body fw-bold">{cellProps.row.original.id}</Link>
                }
            },
            {
                header: "Email",
                accessorKey: "email",
                enableColumnFilter: false,
                enableSorting: true,
            },
            {
                header: "Profile",
                accessorKey: "role.name",
                enableColumnFilter: false,
                enableSorting: true,
            },
            
            
            
            {
                header: 'Action',
                enableColumnFilter: false,
                enableSorting: true,
                cell: (cellProps) => {
                    return (
                        <ul className="list-unstyled hstack gap-1 mb-0">
                            <li>
                                <Link
                                    to="#"
                                    className="btn btn-sm btn-soft-info"
                                    onClick={() => {
                                        const _account = cellProps.row.original;
                                        
                                        onClickEditAccount(_account);
                                    }}
                                    id={`edittooltip-${cellProps.row.original.id}`}
                                >
                                    <i className="mdi mdi-pencil-outline" />
                                    <UncontrolledTooltip placement="top" target={`edittooltip-${cellProps.row.original.id}`} >
                                        Modifier
                                    </UncontrolledTooltip>
                                </Link>
                            </li>

                            {/* If was invited */}
                            {cellProps.row.original.invited && (
                                <li>
                                    <Link
                                        to="#"
                                        className="btn btn-sm btn-soft-info"
                                        onClick={() => {
                                            const _account = cellProps.row.original;
                                            
                                            onClickResendInvitation(_account);
                                        }}
                                        id={`edittooltip-${cellProps.row.original.id}`}
                                    >
                                        <i className="bx bx-revision" />
                                        <UncontrolledTooltip placement="top" target={`edittooltip-${cellProps.row.original.id}`} >
                                            Renvoyer l'invitation
                                        </UncontrolledTooltip>
                                    </Link>
                                </li>

                            )}{/* End If was invited */}

                            {/* If acces locked */}
                            <li>
                                {cellProps.row.original.access_locked ? (
                                    <Link
                                    to="#"
                                    className="btn btn-sm btn-soft-success"
                                    onClick={() => {
                                        const _account = cellProps.row.original;
                                        onUnlockAccountClick(_account);
                                    }}
                                    id={`activatetooltip-${cellProps.row.original.id}`}
                                    >
                                    <i className="bx bx-lock-open" />
                                    <UncontrolledTooltip
                                        placement="top"
                                        target={`activatetooltip-${cellProps.row.original.id}`}
                                    >
                                        Activer le compte
                                    </UncontrolledTooltip>
                                    </Link>
                                ) : (
                                    <Link
                                    to="#"
                                    className="btn btn-sm btn-soft-danger"
                                    onClick={() => {
                                        const _account = cellProps.row.original;
                                        onLockAccountClick(_account);
                                    }}
                                    id={`deactivatetooltip-${cellProps.row.original.id}`}
                                    >
                                    <i className="bx bx-lock" />
                                    <UncontrolledTooltip
                                        placement="top"
                                        target={`deactivatetooltip-${cellProps.row.original.id}`}
                                    >
                                        Désactiver le compte
                                    </UncontrolledTooltip>
                                    </Link>
                                )}
                            </li>
                            {/* If acces locked */}

                            <li>
                                <Link
                                    to="#"
                                    className="btn btn-sm btn-soft-danger"
                                    onClick={() => {
                                        const jobData = cellProps.row.original;
                                        onClickDelete(jobData);
                                    }}
                                    id={`deletetooltip-${cellProps.row.original.id}`}
                                >
                                    <i className="mdi mdi-delete-outline" />
                                    <UncontrolledTooltip placement="top" target={`deletetooltip-${cellProps.row.original.id}`}>
                                        Delete
                                    </UncontrolledTooltip>
                                </Link>
                            </li>
                        </ul>
                    );
                }
            },
        ],
        []
    );

    return (
        <React.Fragment>
            <DeleteModal
                show={deleteModal}
                onDeleteClick={handleDeleteAccount}
                onCloseClick={() => setDeleteModal(false)}
            />
            <InvitationFormModal
                isOpen={modals.invitation}
                toggle={closeAllModals}
                roles={roles}
                onSubmit={(values) => {
                    dispatch(onSendInvitation(values));
                    closeAllModals();
                }}
            />

            <AccountFormModal
                isOpen={accountModal.isOpen}
                toggle={closeAccountModal}
                isEdit={accountModal.isEdit}
                account={accountModal.account}
                roles={roles}
                onSubmit={(values) => {
                    if (accountModal.isEdit) {
                        dispatch(onUpdateAccount(values));
                    } else {
                        dispatch(onAddNewAccount(values));
                    }
                    // closeAccountModal() retiré ici pour laisser la main au useEffect
                }}
            />
            <LockAccountConfirmationModal
                isOpen={modals.lockAccount}
                toggle={closeAllModals}
                onLockAccountClick={handleLockAccount}
                onCloseClick={() => closeAllModals()}
            />
            <UnlockAccountConfirmationModal
                isOpen={modals.unlockAccount}
                toggle={closeAllModals}
                onUnlockAccountClick={handleUnlockAccount}
                onCloseClick={() => closeAllModals()}
            />
            <div className="page-content">
                <div className="container-fluid">
                    <Breadcrumbs title="Utilisateurs" breadcrumbItem="Liste des comptes" />
                    {
                        isLoading ? <Spinners setLoading={setLoading} />
                            :
                            <Row>
                                <Col lg="12">
                                    <Card>
                                        <CardBody className="border-bottom">
                                            <div className="d-flex align-items-center">
                                                <h5 className="mb-0 card-title flex-grow-1"></h5> 
                                                <div className="flex-shrink-0">
                                                    <Link to="#!" onClick={onClickAddAccount} className="btn btn-primary me-1">Créer un utilisateur</Link>
                                                </div>
                                            </div>
                                        </CardBody>
                                        <CardBody>
                                            <TableContainer
                                                columns={columns}
                                                data={accounts || []}
                                                isCustomPageSize={true}
                                                isGlobalFilter={true}
                                                isPagination={true}
                                                SearchPlaceholder="Rechercher ..."
                                                tableClass="align-middle table-nowrap dt-responsive nowrap w-100 table-check dataTable no-footer dtr-inline"
                                                theadClass="table-light"
                                                pagination="pagination"
                                                paginationWrapper="dataTables_paginate paging_simple_numbers pagination-rounded"
                                            />
                                        </CardBody>
                                    </Card>
                                </Col>
                            </Row>
                    }
                   
                </div>
            </div>
            <ToastContainer />
        </React.Fragment>
    );
}

export default Account;